/**
 * @deprecated Use `String` instead.
 */
export const convertToString = String;

export default convertToString;
